// extracted by mini-css-extract-plugin
export default {"info":"_98212af7","associations":"_9c9f533","associationsList":"_eb2c2e31"};